import { BackBtn, Loader } from '@nv/basic-components'
import { useGetEvent } from '@nv/hooks'
import BalletBoxIcon from '@nv/images/design/ballet-box-icon'
import DividerIcon from '@nv/images/design/divider-icon'
import { getEventStateStatus } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import styles from './AdminEventDetailsHeader.module.scss'

export const AdminEventDetailsHeader = ({ eventId }) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  const event = useGetEvent(eventId)
  if (!event) {
    return <Loader />
  }
  const votingOpen = event.state === 'started' && new Date() < new Date(event.closeDate)
  const eventStateStatus = getEventStateStatus(event.state, votingOpen, event.nominationState)
  return (
    <div className={styles['container']}>
      <BackBtn navigateTo={'/admin/dashboard'} />
      <div className={styles['header']}>
        <div className={styles['header__details']}>
          <BalletBoxIcon />
          <span className={styles['header__title']}>{event?.name[currentLanguage]}</span>
          <span className={styles[`header__nominate__${eventStateStatus}`]}>{t(`events.statusLabel.${eventStateStatus}`)}</span>
          <DividerIcon style={{ marginRight: '1.25rem', marginLeft: '1.25rem' }} className={styles['header__divider']} />
          <span className={styles['header__contests']}>{`${event?.questions.length} ${t('events.labels.contests')}`}</span>
        </div>
      </div>
    </div>
  )
}
